// extracted by mini-css-extract-plugin
module.exports =  {"root":"d6tkDi","rootOld":"gLo78N","disclaimersRoot":"EK3sKW","totalSubLabel":"wFLqv9"};